import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Slide,
} from '@material-ui/core';
import styles from './styles';
import globalStyles from '../layout/globalStyles';
import combineStyles from '../../utilities/combineStyles';

const Transition = React.forwardRef( ( props, ref ) => <Slide direction="down" ref={ref} {...props} timeout={{ enter: 500, exit: 10 }} /> );

const SuccessDialog = ( props ) => {
  const {
    classes, surveyStatus,
  } = props;
  const [isOpen, setIsOpen] = useState( true );
  const surveyLink = 'https://docs.google.com/forms/d/e/1FAIpQLScGbdTLl_PGvhXdW9auvSRBo-c5DOmgrOwQBg12AlDMru_KqA/viewform';

  const handleClose = () => {
    setIsOpen( false );
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className={classNames( classes.surveyDialogContainerSize )}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <div className={classNames( classes.defaultDialogContainer, classes.decFirstTimeDialog )}>
          <div className={classes.defaultAlertDialog}>
            <div className={classNames( classes.defaultDialogContainer, classes.decFirstTimeDialog )}>
              <div className={classes.defaultAlertDialog}>
                <h3 className={classes.modalHeading}>Thank you for your time and feedback!</h3>
                {surveyStatus ? (
                  <Typography className={classes.modalIntroText}>
                    We appreciate you taking a moment to share your feedback. Your responses will help us improve your experience on 3ie&quot;s Development Evidence Portal.
                  </Typography>
                ) : (
                  <Typography className={classes.modalIntroText}>
                    We&quot;re sorry, but the survey could not be completed due to a technical issue. Please try again later.
                  </Typography>
                )}
                <div className="d-flex flex-column align-items-center mt-3">
                  <a
                    href={surveyLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.surveyLink}
                    style={{ marginBottom: '16px' }}
                  >
                    Fill out the complete survey →
                  </a>

                  <Button
                    type="button"
                    disableFocusRipple
                    color="primary"
                    onClick={handleClose}
                    className={`${classes.closeButton} ${classes.actionButton}`}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

SuccessDialog.defaultProps = {
  surveyStatus: true,
};

SuccessDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  surveyStatus: PropTypes.bool,
};

const combinedStyles = combineStyles( globalStyles, styles );

export default withStyles( combinedStyles )( SuccessDialog );
